



const fetchSideBarResponse = async (endpoint, request) => {
    let url = ""
    const baseURL = process.env.REACT_APP_BASEURL;
    if (request) {
        url = baseURL + endpoint + '/' + request;
    }
    else {
        url = baseURL + endpoint;
    }

    const response = await fetch(url, {
        method: 'POST'
    });
    if (response.ok) {

        return response.json();
    } else {

        throw new Error('Failed to fetch user data');
    }

}


export default fetchSideBarResponse;